import { inject } from "mobx-react";
import { Fragment, useMemo } from "react";
import { ShareButtons } from "../../../../core/components/integrations/ShareButtons.component";
import { Heading } from "../../../../core/ui";
import { getCoastItemDate } from "../../lib";
import { CoastFeedShowsProps } from "../../lib/coastFeed";
import { CoastFeedAds } from "./CoastFeedAds.component";
import { CoastFeedNoResults } from "./CoastFeedNoResults.component";
import { CoastFeedUpcomingShowItem } from "./CoastFeedUpcomingShowItem.component";

export const CoastFeedUpcomingShows = inject("store")(({ block, store, content, title }: CoastFeedShowsProps) => {
  if (!store) {
    return null;
  }

  const { site, request, env } = store;

  // Upcoming shows are to be displayed soonest to furthest
  const sortedContent = useMemo(() => (content ? [...content].reverse() : []), [content]);

  const timezone = site.index.timeZone || env.DEFAULT_TIMEZONE;
  const dateOutputFormat = "MMMM d, yyyy";

  const fromDate = useMemo(
    () => getCoastItemDate(timezone, dateOutputFormat, sortedContent[0]),
    [sortedContent, timezone],
  );
  const toDate = useMemo(
    () => getCoastItemDate(timezone, dateOutputFormat, sortedContent[sortedContent.length - 1]),
    [sortedContent, timezone],
  );

  const shareUrl = site.getShareUrl(request);

  return (
    <Fragment>
      <Heading level={1}>{title}</Heading>

      <ShareButtons url={shareUrl} title={title} setStyles={false} />

      {fromDate && toDate ? (
        <Heading level={3}>
          Schedule for <time>{fromDate}</time> - <time>{toDate}</time>
        </Heading>
      ) : null}

      {sortedContent.length ? (
        <div className="feed-cards">
          {sortedContent.map((item, itemIdx) => (
            <Fragment key={item.id}>
              <CoastFeedUpcomingShowItem item={item} />
              <CoastFeedAds
                blockSize={block.value.size - 1}
                itemCount={sortedContent.length}
                includeItemAd={false}
                blockId={block.id}
                itemIdx={itemIdx}
              />
            </Fragment>
          ))}
        </div>
      ) : (
        <CoastFeedNoResults />
      )}

      <ShareButtons url={shareUrl} title={title} setStyles={false} />
    </Fragment>
  );
});

export default CoastFeedUpcomingShows;
